<template>
<div class="mb-3">
    <form-question-free-text
        :id="id_computed"
        :request_form="request_form"
        required
        @update-value="updateValue"
    />
</div>
</template>

<script>
import FormQuestionFreeText from '../questions/FormQuestionFreeText.vue';

export default {
    name: 'FormSubmittableComments',
    components: {
        FormQuestionFreeText,
    },
    props: {
        id: {
            type: String,
            required: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
    },
    computed: {
        id_computed() {
            return this.id ?? 'comments';
        }
    },
    methods: {
        updateValue(id, value) {
            this.$emit('update-value', id, value);
        },
    }
}
</script>
